import { DadosPagamentoServicoModel } from "@/models/cadastros/assistencia/DadosPagamentoServicoModel";
import ValoresClienteAdministrativoModel from "@/models/cadastros/assistencia/ValoresClienteAdministrativoModel";
export class ConfirmacaoSolicitacaoFrotaDTO {
  idServico: number;
  idCliente: number;
  idPagamentoCliente: number;
  numeroParcelas: number;
  pagamentoCliente: DadosPagamentoServicoModel;
  valoresAdministrativo?: ValoresClienteAdministrativoModel;
  valoresPrecificado?: ValoresClienteAdministrativoModel;
  idPrestador?: number;
  constructor(idServico: number, idCliente: number, idPagamentoCliente: number, numeroParcelas: number, pagamentoCliente: DadosPagamentoServicoModel, valoresAdministrativo?: ValoresClienteAdministrativoModel, valoresPrecificado?: ValoresClienteAdministrativoModel, idPrestador?: number) {
    this.idServico = idServico;
    this.idCliente = idCliente;
    this.idPagamentoCliente = idPagamentoCliente;
    this.numeroParcelas = numeroParcelas;
    this.pagamentoCliente = pagamentoCliente;
    this.pagamentoCliente = pagamentoCliente;
    this.valoresAdministrativo = valoresAdministrativo;
    this.valoresPrecificado = valoresPrecificado;
    this.idPrestador = idPrestador;
  }
}
